const getTrackingLastCheckpointStyles = theme => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  width: theme.spacing(3),
  height: theme.spacing(3),
  backgroundColor: theme.palette.gray.light,
  color: theme.palette.gray.dark,
  zIndex: theme.elevations.above.zIndex
});
const getTrackingCheckpointDecorationIconStyles = isInitialCheckpoint => theme => ({
  borderRadius: '50%',
  width: theme.spacing(1),
  height: theme.spacing(1),
  backgroundColor: isInitialCheckpoint ? theme.palette.gray.main : theme.palette.gray.light,
  zIndex: theme.elevations.above.zIndex
});

export { getTrackingCheckpointDecorationIconStyles, getTrackingLastCheckpointStyles };
//# sourceMappingURL=TrackingCheckpointDecorationIconStyles.js.map
